/* eslint-disable react/jsx-no-useless-fragment */

"use client"

import { usePathname } from "next/navigation"
import { useEffect } from "react"

export default function Scroll() {
  // when clicking a link, user will not scroll to the top of the page if the header is sticky.
  // their current scroll position will persist to the next page.
  // this useEffect is a workaround to 'fix' that behavior.
  // However, we exclude /insights* pages to allow custom scroll behavior there.

  const pathname = usePathname()

  useEffect(() => {
    // Only scroll to top if NOT on insights pages
    if (!pathname.startsWith("/insights")) {
      window.scroll(0, 0)
    }
  }, [pathname])

  return <></>
}
